import React, { useContext, useEffect, useState } from 'react'
import { format } from 'date-fns'
import {
    FiEye
} from 'react-icons/fi'
import { useHistory } from 'react-router-dom'

import { api, authHeaders } from '../../../../services/api'

import Card from '../../../../components/Card'
import Spinner from '../../../../components/Spinner'
import { Button } from '../../../../components/Form'

import arrayUtils from '../../../../util/array'

import {
    Container, DadosCadastrais, Avatar, ProjetosContainer
} from './styles'

import avatarDefault from '../../../../assets/images/avatar.png'
import { GlobalContext } from '../../../../contexts/GlobalContext'
import { ListaProjetos } from './ListaProjetos'
import { ListaProjetosAvaliacao } from './ListaProjetosAvaliacao'
import { ListaProjetosParticipacao } from './ListaProjetosParticipacao'
import { ListaProjetosAAceitar } from './ListaProjetosAAceitar'

export default function () {
    const history = useHistory()

    const { user, checkException } = useContext(GlobalContext)

    const [pessoa, setPessoa] = useState(null)
    const [projetos, setProjetos] = useState(null)

    async function loadPessoa(pessoaId) {
        try {
            const response = await api.get(`pessoa/${pessoaId}`, authHeaders())
    
            const nomes = response.nome.split(' ')
            response.nome_reduzido = `${nomes[0]} ${nomes.slice(1, nomes.length - 1).map(sobrenome => `${sobrenome[0]}. `).join(' ')}${nomes[nomes.length - 1]}`
    
            setPessoa(response)
        } catch(e) {
            checkException(e)
        }
    }

    async function loadProjetos() {
        try {
            const response = await api.get('projeto', authHeaders())

            setProjetos(response)
        } catch (e) {
            checkException(e)
        }
    }

    useEffect(() => {
        const pessoaId = user?.pessoa.id

        loadPessoa(pessoaId)
    }, [])

    useEffect(() => {
        loadProjetos()
    }, [pessoa])

    if (!projetos) {
        return (
            <Container>
                <Card>
                    <Spinner />
                </Card>
            </Container>
        )
    }

    const projetosAutoria = projetos.filter(proj => proj.projeto_pessoas.find(p => p.pessoa.id === user.pessoa.id).funcao.id === 1)
    const projetosAvaliacao = projetos.filter(proj => [3, 4].includes(proj.projeto_pessoas.find(p => p.pessoa.id === user.pessoa.id).funcao.id))
    const projetosParticipacao = projetos.filter(proj => {
        const projPessoa = proj.projeto_pessoas.find(p => p.pessoa.id === user.pessoa.id)

        return ![1, 3, 4, 5].includes(projPessoa.funcao.id) && projPessoa.aceito === true
    })
    const projetosAAceitar = projetos.filter(proj => proj.projeto_pessoas.find(pp => pp.pessoa.id === user.pessoa.id).aceito === null)

    return (
        <>
            <Container>
                <main className="animated fadeIn faster">
                    <DadosCadastrais>
                        <Card className="animated fadeIn delay-100ms">
                            {pessoa ? (
                                <>
                                    <Avatar
                                        image={pessoa.usuario?.avatar?.link || avatarDefault}
                                        className="animated zoomIn faster"
                                    />

                                    <h1 className="nome_completo">
                                        {pessoa.nome}
                                    </h1>
                                    <h1 className="nome_reduzido">
                                        {pessoa.nome_reduzido}
                                    </h1>

                                    <div style={{ gridArea: 'detail_button', justifySelf: 'end' }} className="detail-button">
                                        <Button className="transparent" onClick={() => { history.push('/associado/dados_cadastrais') }}>
                                            <span>Meu cadastro</span>
                                            <FiEye size={18} />
                                        </Button>
                                    </div>

                                    <div style={{ gridArea: 'crm' }} className="crm flex gap-2">
                                        <span>CPF:</span>

                                        <b style={{ fontSize: 18 }}>
                                            {pessoa.documentos.find(documento => documento.tipo_documento.id === 2).identificador}
                                        </b>
                                    </div>

                                    <div style={{ gridArea: 'data' }}>
                                        {pessoa.associado.status_associacao.id === 3 && pessoa.associado.sindicalizacao.length ? (
                                            <>
                                                <span>Data de cadastro: </span>
                                                <b>{pessoa.associado.sindicalizacao.length ? format(new Date(pessoa.associado.sindicalizacao.filter(sindicalizacao => sindicalizacao.status).sort(arrayUtils.sort.comparisonFunction('data', 'desc'))[0].data), 'dd/MM/yyy') : ''}</b>
                                            </>
                                        ) : null}
                                    </div>
                                </>
                            ) : (
                                <Spinner />
                            )}
                        </Card>
                    </DadosCadastrais>

                    <ProjetosContainer>
                        <div className="flex flex-col">
                            <Card className="animated fadeIn">
                                <ListaProjetos projetos={projetosAutoria} />
                            </Card>

                            <Card className="animated fadeIn delay-100ms">
                                <ListaProjetosParticipacao projetos={projetosParticipacao} />
                            </Card>
                        </div>

                        <div className="flex flex-col">
                            <Card className="animated fadeIn delay-100ms">
                                <ListaProjetosAvaliacao projetos={projetosAvaliacao} />
                            </Card>

                            <Card className="animated fadeIn delay-100ms">
                                <ListaProjetosAAceitar projetos={projetosAAceitar} />
                            </Card>
                        </div>
                    </ProjetosContainer>
                </main>
            </Container>
        </>
    )
}
